import React, { useEffect, useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { userrights } from '../../components/commonClass/CommonInterfaceTypes';

function TravelAgentLayout() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector((store: any) => store.userstatus.tba);
    const menuItem = useSelector((store: any) => store.menuitems.menu);
    const [userRights, setUserRights] = useState<userrights>();

    useEffect(() => {
        //check for rights
        if (user) {
            // /travel-agent-management
            const pathname = window?.location?.pathname?.toLowerCase() === "/travel-agent-management/create-agent"?.toLowerCase() ?
                "/travel-agent-management"?.toLowerCase()
                : window?.location?.pathname?.toLowerCase()
            if (window?.location?.pathname === "/travel-agent-management/create-agent") {
            }
            const hasRights: userrights = user?.find((fil: any) => fil?.PageLink?.toLowerCase() === pathname)
            setUserRights(hasRights)
            if (!hasRights?.URightView) {
                navigate('/dashboard');
            }
        }
    }, [user]);

    return (
        <>
            <div className="mx-2 mt-0 mb-3 heading_color">
                <h2 className='fw-bold'> Travel Agent Management </h2>
            </div>

            <div>
                <Outlet context={{ userRights }} />
            </div>
        </>
    )
}

export default TravelAgentLayout